import { deepOmit } from "utils/utils";

export const cleanGQLData = <T>(data: unknown): T => {
	const cleanedData = deepOmit(data, ["__typename"]);
	return cleanedData as T;
};
